import { render } from "./IndexBdd.vue?vue&type=template&id=2102cce8"
import script from "./IndexBdd.vue?vue&type=script&lang=js"
export * from "./IndexBdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__